module.exports = __webpack_public_path__ + "media/images/home/bg-4-8d25469bcb08df28c7d67d1f77c04083.png";